import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button } from "antd";
import {
  Row,
  Form,
  Input,
  Col,
  Select,
  Collapse,
  notification,
  Popconfirm,
} from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  MinusCircleTwoTone,
  PlusCircleTwoTone,
  DeleteOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import CoolingShelfApi from "../../common/Apis/CoolingShelfApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
const CoolingShelf = () => {
  const navigate = useNavigate();
  const [formadd2] = Form.useForm();
  const { Content } = Layout;
  const { Panel } = Collapse;

  const [CoolingShelf, setCoolingShelf] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    CoolingShelfApi.ListCoolingShelf(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setCoolingShelf(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    CoolingShelfApi.ListCoolingShelf(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setCoolingShelf(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCoolingShelf = useCallback(() => {
    CoolingShelfApi.ListCoolingShelf(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setCoolingShelf(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getCoolingShelf();
  }, [PageLoading, getCoolingShelf]);

  const handleRemovefilterCoolingShelf = (FiltergetCoolingShelfIndex) => {
    const newfilterCoolingShelf = [...filterCoolingShelf];
    newfilterCoolingShelf.splice(FiltergetCoolingShelfIndex, 1);
    setFilterCoolingShelf(newfilterCoolingShelf);
    if (FiltergetCoolingShelfIndex == 0) {
    }
  };
  const handleClear = () => {
    setIsLoading(true);
    getCoolingShelf();
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterCoolingShelf([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterCoolingShelf, setFilterCoolingShelf] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterCoolingShelf = () => {
    setFilterCoolingShelf([
      ...filterCoolingShelf,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterCoolingShelf
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
        "componentCode=COOLING_SHELF_LIFE&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setCoolingShelf(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FiltergetCoolingShelfIndex, value) => {
    const newfilterCoolingShelf = [...filterCoolingShelf];
    newfilterCoolingShelf[FiltergetCoolingShelfIndex].title = value;
    setFilterCoolingShelf(newfilterCoolingShelf);

    const fieldName = 'name' + FiltergetCoolingShelfIndex;
    const fieldName2 = 'nameto' + FiltergetCoolingShelfIndex;
    formadd2.setFieldsValue({
      [fieldName]: null,
      [fieldName2]: null,
    });
  };
  const handleChangeAnswertype = (FiltergetCoolingShelfIndex, value) => {
    const newfilterCoolingShelf = [...filterCoolingShelf];
    newfilterCoolingShelf[FiltergetCoolingShelfIndex].answerType = value;
    setFilterCoolingShelf(newfilterCoolingShelf);
  };

  const handleChangename = (FiltergetCoolingShelfIndex, value) => {
    const newfilterCoolingShelf = [...filterCoolingShelf];
    newfilterCoolingShelf[FiltergetCoolingShelfIndex].name = value;
    setFilterCoolingShelf(newfilterCoolingShelf);
  };

  const paginatedData = CoolingShelf;

  const handleDeleteShelfLife = (ShelfLifeID) => {
    CoolingShelfApi.DeleteCoolingShelf(ShelfLifeID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getCoolingShelf();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td className="pt-3">
            {item?.period}
          </td>
          <td style={{ width: "15%" }} className="pt-3">
            {item?.periodType}
          </td>
          <td style={{ width: "25%" }} className="pt-3">
            {item?.description}
          </td>

          <td style={{ width: "12%" }} >
            <Popconfirm
              title="Are you sure ?"
              description="Do you really want to delete this Cooling Shelf ?"
              okText="Yes"
              placement="topRight"
              className="w-100"
              onConfirm={() => handleDeleteShelfLife(item.id)}
              cancelText="No"
            >
              <Link
                to={``}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'DELETE_COOLING_SHELF_LIFE'
                ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
              >
                <DeleteOutlined />
                Delete
              </Link>
            </Popconfirm>

          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={4} className="text-center ">
            <EmptyBox />
            <br />
            {/* <Button
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_COOLING_SHELF_LIFE'
              ) ? 'btn btn-primary btn-save m-0 my-2 mt-4' : 'd-none'}
              href={"/masters/Cooling-Shelf/add-Cooling-Shelf"}
              style={{ width: "30%" }}
            >
              Add Cooling Shelf
            </Button> */}
            <Button
              type="primary"
              onClick={() => navigate('/masters/cooling-shelf/add-cooling-shelf')}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_COOLING_SHELF_LIFE'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add new cooling shelf
            </Button>
          </td>
        </tr>
      );
    }
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            form={formadd2}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterCoolingShelf.map((input, filterCoolingShelfIndex) => (
                    <div key={filterCoolingShelfIndex}>
                      <Row gutter={24} className="pt-2">
                        <Col lg={5} md={5} className="px-1">
                          <Form.Item
                            name={`title${filterCoolingShelfIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(
                                  filterCoolingShelfIndex,
                                  value
                                )
                              }
                              options={[
                                {
                                  value: "period",
                                  label: "Period",
                                },
                                {
                                  value: "periodType",
                                  label: "Period Type",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        {filterCoolingShelf[filterCoolingShelfIndex].title ==
                          "periodType" ? (
                          <>

                          </>
                        ) : (
                          <>
                            <Col lg={4} md={4} className="px-1">
                              <Form.Item
                                name={`type${filterCoolingShelfIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterCoolingShelfIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}

                        <Col lg={5} md={5} className="px-1">
                          {filterCoolingShelf[filterCoolingShelfIndex].title ==
                            "periodType" ? (
                            <>
                              <Form.Item
                                name={`name${filterCoolingShelfIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Period Type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select"
                                  placeholder="Select Period Type"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterCoolingShelfIndex,
                                      e
                                    )
                                  }
                                >
                                  <option value={"DAYS"}>Days</option>
                                  <option value={"WEEKS"}>Weeks</option>
                                  <option value={"MONTHS"}>Months</option>
                                  <option value={"YEARS"}>Years</option>
                                </Select>

                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterCoolingShelfIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterCoolingShelfIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col lg={8} md={10} className="px-1">
                          <Form.Item className="text-lable">
                            {filterCoolingShelfIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterCoolingShelf}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterCoolingShelf(
                                      filterCoolingShelfIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>

                {paginatedData?.length > 0 && (
                  <Button
                    type="primary"
                    onClick={() => navigate('/masters/cooling-shelf/add-cooling-shelf')}
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_COOLING_SHELF_LIFE'
                      ) ? '' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                  >
                    Add new cooling shelf
                  </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>

            <table className="table users-table">
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Period Type</th>
                  <th>Description</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default CoolingShelf;
